import { render } from "./AceEditor.vue?vue&type=template&id=2e922905"
import script from "./AceEditor.vue?vue&type=script&lang=js"
export * from "./AceEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__